import { render, staticRenderFns } from "./TicketModalDesktop.vue?vue&type=template&id=30177520"
import script from "./TicketModalDesktop.vue?vue&type=script&lang=js"
export * from "./TicketModalDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports